import React from 'react';
import styles from './templates.module.scss';

export default function Subtitle({ text }) {
  return <label className={styles.subtext}>{text}</label>;
}
